exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.width-75[data-v-54bff316] {\n    width: 75px;\n}\n.width-auto[data-v-54bff316] {\n    width: auto;\n}\n@media screen and (max-width: 500px) {\n.width-auto[data-v-54bff316],\n    .width-75[data-v-54bff316] {\n        width: 100%;\n}\n.width-auto + .width-auto[data-v-54bff316],\n    .width-auto + .width-75[data-v-54bff316] {\n        margin-top: .5em;\n}\n}\n", ""]);

// exports
